module.exports = __webpack_public_path__ + "media/images/planning_a_trip_to_japan/th/1/3-1d75e0c143ff9d52dd78742e37903b0f.jpg";